import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
import { LANGUAGES, LOCALE } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { SpokenLanguageIcon } from '@winelidays/wld-tsx-2/images';
import { Languages } from '@winelidays/wld-tsx-2/modules';
import PracticalLine from '../PracticalLine';
const LanguageContent = t0 => {
    const $ = _c(3);
    const { informations } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== informations || $[1] !== translate) {
        t1 = "spokenLangs" in informations ? <PracticalLine icon={<SpokenLanguageIcon />} label={translate("practical.spoken_languages")} content={<Languages languages={informations.spokenLangs} translate={translate} locale={LOCALE} langs={LANGUAGES} imgComponent={Img}/>} labelClassName="mr-3"/> : null;
        $[0] = informations;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    return t1;
};
export default LanguageContent;
